import { useState } from 'react'
import { Sidebar } from './Sidebar'
import { MobileSidebarDrawer } from './MobileSidebarDrawer'
import { Header } from './Header'

interface AppShellProps {
  readonly children: React.ReactNode
}

export function AppShell({ children }: AppShellProps) {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const closeDrawer = () => setDrawerOpen(false)

  return (
    <div className="flex h-screen bg-background">
      <Sidebar />
      <MobileSidebarDrawer open={drawerOpen} onClose={closeDrawer} />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header onOpenSidebar={() => setDrawerOpen(true)} />
        <main className="flex-1 overflow-auto p-4 sm:p-6">{children}</main>
      </div>
    </div>
  )
}
